import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-tooltip"]
const _hoisted_2 = { class: "counter__value" }
const _hoisted_3 = {
  key: 0,
  class: "counter__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.parsedValue)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["counter__container", `${_ctx.type} display__${_ctx.display} position__${_ctx.position} offset-${_ctx.offset} ${_ctx.parsedTooltip && 'has-tooltip'}`]),
        "data-tooltip": _ctx.parsedTooltip,
        style: _normalizeStyle(`--index: ${_ctx.index}; --content-length: ${typeof _ctx.parsedValue === 'boolean' ? '1' : _ctx.parsedLabel ? (_ctx.parsedLabel.length + _ctx.parsedValue.toString().length) : 0}; --content: ${_ctx.label}`),
        "data-cy": "counter-container"
      }, [
        _renderSlot(_ctx.$slots, "prepend", {}, undefined, true),
        _createElementVNode("div", _hoisted_2, _toDisplayString(typeof _ctx.parsedValue === 'boolean' ? '●' : _ctx.parsedValue), 1),
        (_ctx.parsedLabel && (typeof _ctx.parsedValue !== 'boolean'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " " + _toDisplayString(_ctx.parsedLabel), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "apend", {}, undefined, true)
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}